module.exports = __webpack_public_path__ + "static/media/maker_dao.a34113b4.png";